export const SAVED = 'Отложить';
export const SAVE = 'Отложено';


// WEBPACK FOOTER //
// ./src/pages/activities/card/button-deferred/const.ts